import { useState } from "react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";
import { MapPin, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Message sent!");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  const field = "w-full bg-transparent border-b border-mj-border py-3 font-sans-mj text-mj-text placeholder:text-mj-muted/60 focus:outline-none focus:border-mj-red transition-colors";

  return (
    <div data-testid="contact-page" className="pt-32 min-h-screen">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32">
        <Reveal><span className="overline text-mj-golddeep">Contact Us</span></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-mj tracking-tight text-mj-text mt-6 text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            Let's <span className="italic text-mj-red">talk</span>
          </h1>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-16 md:gap-24 mt-20">
          {/* Info */}
          <div>
            <Reveal>
              <div className="flex gap-4 mb-10">
                <MapPin className="w-5 h-5 text-mj-red shrink-0 mt-1" strokeWidth={1.4}/>
                <div>
                  <p className="overline text-mj-muted mb-2">Visit / Write to us</p>
                  <p className="font-serif-mj text-2xl leading-snug text-mj-text">
                    Manjaadii Ethnics OPC Pvt. Ltd.<br/>
                    VTC Rampura, PO Bidrahalli,<br/>
                    Bangalore South, Karnataka — 560049
                  </p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <a href="mailto:Contact@manjaadii.com" className="flex gap-4 mb-6 group">
                <Mail className="w-5 h-5 text-mj-red shrink-0" strokeWidth={1.4}/>
                <span className="font-serif-mj text-2xl text-mj-text group-hover:text-mj-red transition-colors">Contact@manjaadii.com</span>
              </a>
            </Reveal>
            <Reveal delay={0.15}>
              <a href="tel:9739209737" className="flex gap-4 group">
                <Phone className="w-5 h-5 text-mj-red shrink-0" strokeWidth={1.4}/>
                <span className="font-serif-mj text-2xl text-mj-text group-hover:text-mj-red transition-colors">+91 97392 09737</span>
              </a>
            </Reveal>
          </div>

          {/* Form */}
          <Reveal delay={0.2}>
            <form onSubmit={submit} data-testid="contact-form" className="flex flex-col gap-8">
              <input data-testid="contact-name" required placeholder="Your name" className={field}
                value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input data-testid="contact-email" type="email" required placeholder="Email address" className={field}
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input data-testid="contact-phone" placeholder="Phone (optional)" className={field}
                value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <textarea data-testid="contact-message" required placeholder="Your message" rows={4} className={field}
                value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              <button data-testid="contact-submit" disabled={loading} type="submit"
                className="bg-mj-red text-mj-bg py-4 overline hover:bg-mj-reddark transition-colors disabled:opacity-60 mt-2">
                {loading ? "Sending…" : "Send Message"}
              </button>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
